



































import {Component, Vue} from 'vue-property-decorator';

@Component
export default class MemberCrmNav extends Vue {
  private handleTabChange(): void {
    this.$emit('tabChange');
  }
  changeCrmModule(path:string,routeName){
    if(routeName===this.$route.name){
      location.reload()
    }else{
      this.$router.push(path)
    }
  }
}
